export function millisToHoursAndMinutesAndSeconds(millis: number) {
    var totalSeconds = Math.floor(millis / 1000)

    var hours = '' + Math.floor(totalSeconds / 3600);
    var minutes = '' + (Math.floor(totalSeconds / 60) % 60);
    var seconds = '' + Math.floor(totalSeconds % 60);

    return hours.padStart(2, '0') + ":" + minutes.padStart(2, '0') + ":" + seconds.padStart(2, '0');
}

export function datetimeToFormatString(dateTime: Date | undefined, options: Intl.DateTimeFormatOptions) {
    if (isNaN(Number(dateTime)) || dateTime === undefined)
        return "";
    return new Date(dateTime).toLocaleDateString("en-GB", options);
}

export function formatDate(date: Date | string | null | undefined): string {
  if (!date) return "—";

  const d = new Date(date);

  if (Number.isNaN(d.getTime())) return "—";

  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
}